import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_purchase_credit_notes",
  version: "1.2.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`accounting_purchase_credit_notes\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`invoice_no\` text NOT NULL,
  \`company_id\` text NOT NULL,
  \`branch_id\` text,
  \`invoice_type\` text DEFAULT 'credit_note' NOT NULL,
  \`party_type\` text DEFAULT 'supplier' NOT NULL,
  \`party_id\` text NOT NULL,
  \`invoice_date\` text NOT NULL,
  \`due_date\` text,
  \`subtotal\` real DEFAULT 0 NOT NULL,
  \`tax_amount\` real DEFAULT 0 NOT NULL,
  \`total_discount\` real DEFAULT 0,
  \`total_wht\` real DEFAULT 0,
  \`total\` real DEFAULT 0 NOT NULL,
  \`outstanding\` real DEFAULT 0 NOT NULL,
  \`doc_status\` integer DEFAULT 0 NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`credit_note_of\` text,
  \`debit_note_of\` text,
  \`reason\` text,
  \`original_invoice_amount\` real,
  \`corrected_amount\` real,
  \`difference_amount\` real,
  \`reason_code\` text,
  \`currency_code\` text DEFAULT 'THB',
  \`exchange_rate\` real DEFAULT 1,
  \`transaction_type\` text,
  \`delivery_date\` text,
  \`tax_point_date\` text,
  \`vat_status\` text DEFAULT 'due',
  \`vat_period\` text,
  \`remarks\` text,
  \`reference_module\` text,
  \`reference_doctype\` text,
  \`reference_id\` text,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  CONSTRAINT \`accounting_purchase_credit_notes_owner_chk\` CHECK (\`invoice_type\` = 'credit_note' AND \`party_type\` = 'supplier')
);
CREATE UNIQUE INDEX IF NOT EXISTS \`accounting_purchase_credit_notes_invoice_no_unique\` ON \`accounting_purchase_credit_notes\` (\`invoice_no\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_status_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`status\`, \`invoice_date\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_party_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`party_type\`, \`party_id\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_type_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`invoice_type\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_branch_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`branch_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`apcn_credit_note_of_idx\` ON \`accounting_purchase_credit_notes\` (\`credit_note_of\`);
CREATE INDEX IF NOT EXISTS \`apcn_debit_note_of_idx\` ON \`accounting_purchase_credit_notes\` (\`debit_note_of\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_vat_period_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`vat_period\`, \`vat_status\`);
CREATE INDEX IF NOT EXISTS \`apcn_company_tax_point_idx\` ON \`accounting_purchase_credit_notes\` (\`company_id\`, \`tax_point_date\`, \`vat_status\`);
CREATE TRIGGER IF NOT EXISTS \`accounting_purchase_credit_notes_owner_insert_guard\` BEFORE INSERT ON \`accounting_purchase_credit_notes\` FOR EACH ROW WHEN NEW.\`invoice_type\` <> 'credit_note' OR NEW.\`party_type\` <> 'supplier' BEGIN SELECT RAISE(ABORT, 'accounting_purchase_credit_notes owner discriminator violation'); END;
CREATE TRIGGER IF NOT EXISTS \`accounting_purchase_credit_notes_owner_update_guard\` BEFORE UPDATE OF \`invoice_type\`, \`party_type\` ON \`accounting_purchase_credit_notes\` FOR EACH ROW WHEN NEW.\`invoice_type\` <> 'credit_note' OR NEW.\`party_type\` <> 'supplier' BEGIN SELECT RAISE(ABORT, 'accounting_purchase_credit_notes owner discriminator violation'); END;
  `.trim(),
};
